import {
  Component,
  h,
  createApp,
  getCurrentInstance,
  reactive,
} from 'vue';
import Loading from './loading.vue';
import Routing from './routing.vue';

function mountComponent(Component: Component) {
  const app = createApp(Component);
  const container = document.createElement('div');
  document.body.appendChild(container);
  return {
    instance: app.mount(container),
    unmount() {
      app.unmount();
      container.remove();
    },
  };
}

type CopOptionsType = {
  loading: Component;
  routing: Component;
};

const CopOptions: CopOptionsType = {
  loading: Loading,
  routing: Routing,
};

const createInstance = (type: string) => {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const { instance, unmount } = mountComponent({
    setup() {
      const state = reactive({
        show: false,
        opening: false,
      });

      const close = () => {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        state.show = false;
        state.opening = false;
        setTimeout(() => {
          unmount();
        }, 200);
      };

      const open = (delay = 500) => {
        if (state.opening) return;
        state.opening = true;
        timer = setTimeout(() => {
          state.show = true;
        }, delay);
      };

      const render = () => {
        const Comp = CopOptions[type as keyof CopOptionsType];
        return h(Comp, { show: state.show });
      };
      (getCurrentInstance() as any).render = render;

      return {
        close,
        open,
      };
    },
  });

  return instance;
};

export function showLoading({ delay = 500, type = 'loading' }: { delay?: number; type?: string } = {}) {
  const instance = createInstance(type) as unknown as { close: () => void; open: (delay?: number) => void };
  instance.open(delay);
  return instance;
}
